import { createAsyncThunk } from "@reduxjs/toolkit";
import { postHeightUserUrl } from "../../fakebackend_helper";
import axios from "axios";

export const GetDailyDataDashUser = createAsyncThunk(
  "dietPlan/getDailyDataDashUser",
  async ({ dailyMealID, dailyMealPlanId }, { rejectWithValue }) => {
    try {
      const authUser = JSON.parse(sessionStorage.getItem("authUser"));
      const token = authUser?.data?.data?.token;

      // Construction explicite de l’URL comme dans Swagger
      const url = `http://95.111.225.198:8082/usersApi/api/logs/log-Meal-Consumption?dailyMealID=${dailyMealID}&dailyMealPlanId=${dailyMealPlanId}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/hal+json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response;
    } catch (error) {
      console.error("Erreur API:", error.response || error);
      return rejectWithValue(error.response || "Erreur inconnue");
    }
  }
);



  export const GetListDataHeigthOfUser = createAsyncThunk(
    "dietPlan/GetListDataHeigthOfUser",
    async (userId, { rejectWithValue }) => {
      console.log("GetListDataHeigthOfUser called with ID:", userId); // Vérification
  
      try {
       
  
        // 🔥 Intégration correcte de userId dans l'URL
        const response = await axios.get(
          `http://95.111.225.198:8082/usersApi/api/logs/get-User-Weight-Logs/${userId}`
        );
  
        console.log("Réponse API:", response.data);
        return response.data;
      } catch (error) {
        console.error("Erreur API:", error.response?.data || error);
        return rejectWithValue(error.response?.data || "Erreur inconnue");
      }
    }
  );
  


  export const PostHeightUser = createAsyncThunk(
    "dietPlan/postHeigthOfUser",
    async (weight, { rejectWithValue }) => {
      try {
        const response = await postHeightUserUrl(weight);
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data || "Erreur lors de l’enregistrement du poids"
        );
      }
    }
  );
  